export const zh = {
  "Type": "类型",
  "Folder": "目录",
  "Dynamic": "目录(动态)",
  "Link": "内部链接",
  "ExternalLink": "外部链接",
  "RedirectLink": "跳转链接",
  "Name": "名称",
  "Url": "路径",
  "ModuleUrl": "功能模块",
  "Icon": "图标",
  "MenuApiUrl": "菜单获取地址",
  "HttpUrl": "链接地址",
  "Description": "描述",
  "Move": "移动",
  "Action": "操作",
  "AddMenu": "新增菜单",
  "EditMenu": "编辑菜单",
  "Export": "导出",
  "Import": "导入",
  "OK": "确定",
  "Cancel": "取消",
  "AddTranslation": "添加翻译"
};

